module.exports = __webpack_public_path__ + "static/media/Portrait-10209.73abd397.jpg";